import { httpService } from "./httpService";

/**
 * Admin-only aggregated system health snapshot.
 * Backs SystemHealthPage. See backend SystemHealthController.
 */
export const getSystemHealth = async () =>
  httpService({
    url: "/admin/system-health",
    options: { method: "GET" },
  });
